import React from 'react';
import { statusColor, statusBg } from '../../utils/format';

interface BadgeProps { status: string; label?: string; }

export const Badge: React.FC<BadgeProps> = ({ status, label }) => (
  <span style={{
    display: 'inline-block', padding: '2px 10px', borderRadius: 20,
    fontSize: 12, fontWeight: 500, background: statusBg(status), color: statusColor(status),
  }}>{label || status}</span>
);
